import { render, staticRenderFns } from "./NewRole.vue?vue&type=template&id=6215350e&scoped=true"
import script from "./NewRole.vue?vue&type=script&lang=js"
export * from "./NewRole.vue?vue&type=script&lang=js"
import style0 from "./NewRole.vue?vue&type=style&index=0&id=6215350e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215350e",
  null
  
)

export default component.exports